import {
  JSEncrypt
} from "jsencrypt";
import commonConfig from '@/config/common-config.js';
const {
  XXTEA
} = require("@/common/encrypt/XXTEA.js");
import {
  fileQueryAPI
} from '@/api/file.js'
import {
  Seal
} from '@pansy/seal';
import Vue from 'vue'

function deepClone(obj) {
  let newObj = Array.isArray(obj) ? [] : {}

  if (obj && typeof obj === "object") {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        newObj[key] = (obj && typeof obj[key] === 'object') ? deepClone(obj[key]) : obj[key];
      }
    }
  }
  return newObj
}

function splitK(num, int, noFh) {
  if (num || num === 0) {
    num = Number(num).toFixed(2);
    let fh = "";
    num = String(num);
    if (num.indexOf('-') > -1) {
      fh = '-';
      num = num.slice(1);
    }
    let decimal = String(num).split('.')[1] || '00'; //小数部分
    let tempArr = [];
    let revNumArr = String(num).split('.')[0].split("").reverse(); //倒序
    for (let i in revNumArr) {
      tempArr.push(revNumArr[i]);
      if ((i + 1) % 3 === 0 && i != revNumArr.length - 1) {
        tempArr.push(',');
      }
    }
    let zs = tempArr.reverse().join(''); //整数部分
    if (!int) return decimal ? (noFh ? '' : fh) + zs + '.' + decimal : (noFh ? '' : fh) + zs;
    if (int) return (noFh ? '' : fh) + zs;
  }
  return "0.00";
}

function dateFormat(date, format, addMonth, addDates) {
  if (format === undefined) {
    format = date;
    date = new Date();
  }
  const map = {
    'M': date.getMonth() + 1, // 月份
    'd': date.getDate(), // 日
    'h': date.getHours(), // 小时
    'm': date.getMinutes(), // 分
    's': date.getSeconds(), // 秒
    'q': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  };
  format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
    let v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v;
        v = v.substr(v.length - 2);
      }
      return v;
    } else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length);
    }
    return all;
  });

  const connector = /[^\d]/.exec(format)[0];
  let [year, month, aDate] = format.split(connector);

  const isLeapYear = leapYear(+year);

  const days_31 = [1, 3, 5, 7, 8, 10, 12];
  const days_30 = [4, 6, 9, 11];

  if (addDates) {
    if (days_31.includes(Number(month))) {
      if (Number(aDate) + addDates > 31) {
        aDate = (Number(aDate) + addDates - 31);
        if (+month === 12) {
          month = '01';
          year = +year + 1;
        } else {
          month = +month + 1;
        }

      } else {
        aDate = Number(aDate) + addDates;
      }
    } else if (days_30.includes(Number(month))) {
      if (Number(aDate) + addDates > 30) {
        aDate = (Number(aDate) + addDates - 30);
        month = +month + 1;
      } else {
        aDate = Number(aDate) + addDates;
      }
    } else {
      if (isLeapYear) {
        if (Number(aDate) + addDates > 29) {
          aDate = (Number(aDate) + addDates - 29);
          month = +month + 1;
        } else {
          aDate = Number(aDate) + addDates;
        }
      } else {
        if (Number(aDate) + addDates > 28) {
          aDate = (Number(aDate) + addDates - 28);
          month = +month + 1;
        } else {
          aDate = Number(aDate) + addDates;
        }
      }
    }
    if (Number(aDate) < 10) {
      aDate = '0' + Number(aDate);
    }
    if (+month < 10) {
      month = '0' + Number(month);
    }
    format = [year, month, aDate].join(connector);
  }

  if (addMonth) {
    if (+month + addMonth > 12) {
      month = (+month + addMonth - 12);
      year = year + 1;
    } else {
      month = +month + addMonth;
    }
    if (+month < 10) {
      month = '0' + Number(month);
    }
    format = [year, month, aDate].join(connector);
  }
  return format;
}

function getDate(value, fmt, now) {
  if (!value) return "";
  value = now ? "" : value;


  if (typeof (value) === 'string' && !value.includes('T')) {
    value = value.replace(/-/g, "/");
  }

  let date = new Date(value);
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString() // 秒
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    }
  }
  return fmt;
}

function leapYear(year) {
  return !(year % (year % 100 ? 4 : 400));
}

function isUndefined(value) {
  return !value && value !== 0;
}
//限制input只能输入数字，小数点最多两位
function clearNoNum(objval, int, start, negative) { //int:整数  start:可以0开头,negative:可以负数
  if (!objval) return 0;
  if (int == 'int') {
    objval = objval.replace(/[^\d]/g, "");
  } else {
    if (negative) {
      objval = objval.replace(/[^\d.-]/g, ""); //清除“数字”和“.-”以外的字符
    } else {
      objval = objval.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
    }
  }

  objval = objval.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
  objval = objval.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");

  if (negative) {
    objval = objval.replace(/\-{2,}/g, "-"); //只保留第一个- 清除多余的
    objval = objval.replace("-", "$#$").replace(/\-/g, "").replace("$#$", "-");
  }
  objval = objval.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
  if ((objval.indexOf(".") < 0 && objval.indexOf("-") < 0) && objval != "" && objval.length > 1) { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    if (!start) {
      objval = parseFloat(objval);
    }
  }
  return objval;
}

function getPasswordEncryptString(pwdStr) {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(getEncryptKey());
  return encrypt.encrypt(pwdStr);
}
// 加密
function getEncryptKey(key = 'pub') {
  return `-----BEGIN PUBLIC KEY-----
		MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCJs93/+qTGnMr68IZoEZjmwlki
		J5lhD+HE6GQMiu/giAjCthA2G8+ri679/FmsryLXqUOEUSYBVmkl2gjmD8XhgYx9
		BEfO00qhz5uvnhTLNN4RKha8Epsx07EqTm6+LWYdFwuf4MIlKVy3B1YZN9qamyWe
		lXoiDILtf78vFLvnOQIDAQAB
	-----END PUBLIC KEY-----`;
}

function getXxtexKey() {
  return '789aa4f8888f20fb0781f6f6bb94b0fe';
}

// 单个加密-解密
function getUrlEncrypt(parm) {
  return XXTEA.encryptToBase64(String(parm), commonConfig.config.pubKey).replace(/\//g, '\\');
}

function getUrlDecrypt(parm) {
  return XXTEA.decryptFromBase64(String(parm).replace(/\\/g, '\/'), commonConfig.config.pubKey);
}

// 数据某项加密-解密
function encryptItemFromArray(items, key = 'id') {
  items.forEach(item => {
    const flag = item.hasOwnProperty(key);
    item[key] = flag && getUrlEncrypt(item[key]);
  });
  return items;
}

// 待定
function decryptItemFromArray(items, key = 'id') {
  items.forEach(item => {
    const flag = item.hasOwnProperty(key);
    item[key] = flag && getUrlDecrypt(item[key]);
  });
  return items;
}

const regExpObj = {
  // MOBILE_PATTERN:/(^|\s*\+?0?0?86|\D)(1\d{2})[-\s]{0,3}(\d{4})[-\s]{0,3}(\d{4})(?=\D|$)/,
  MOBILE_PATTERN: /^(13|14|15|16|17|18|19)[0-9]\d{8}$/,
  // PASSWORD_PATTERN: /^(?![^a-zA-Z]+$)(?!\D+$)(?![~!@#$%^&*]+$)[a-zA-Z0-9~!@#$%^&*]{8,20}$/,
  PASSWORD_PATTERN: /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*()_.]+)$)^[\w~!@#$%^&*()_.]{8,16}$/,
  EMAIL_PATTERN: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
  PHONE_PATTERN: /^((0\d{2,3}\d{7,8})|(1[3584]\d{9}))$/,
  ALPHABET_NUMBER_PATTERN: /^[a-z0-9]+$/i,
  CHARACTER_PATTERN: /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
  NUMBER_PATTERN: /^\d*$/,
  CHARACTER_NUMBER_PATTERN: /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、\d]*$/,
  USERNAME_PATTERN: /^[\u4e00-\u9fa5_-a-zA-Z0-9]{8,20}$/,
  IDCARD_PATTERN: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  // MOBILE_FIXED: /(^(\d{3,4}-)?\d{7,8})$|^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
  MOBILE_FIXED: /^(13|14|15|16|17|18|19)[0-9]\d{8}$/,
  PASSPORT: /^[A-Z,a-z]{2}\d{7,10}$/,
}

/**
 * 处理文件流，下载文件
 * @param blob
 * @param fileName
 */
function fileDownload(blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(new Blob([blob]), fileName);
  } else {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(new Blob([blob], {
      type: 'text/csv,charset=UTF-8'
    }));
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
}

function creditCode(value) {
  // 社会信用代码白名单
  const creditCodeWhite = ["1234567G930146954G", "1234567G332333178G", "1234567G414992783G", "91440104BXW94L25XP", "914401022JX0K99K9Q", "91440103APD96N95XF", "914401045909MJG36K"];
  if (creditCodeWhite.indexOf(value) > -1) {
    return true;
  }

  const patrn = /^[0-9A-Z]+$/;
  if (!value) {
    return true;
  }
  // 18位校验及大写校验
  if ((value.length !== 18) || !patrn.test(value)) {
    return false;
  } else {
    let Ancode; // 统一社会信用代码的每一个值
    let Ancodevalue; // 统一社会信用代码每一个值的权重
    let total = 0;
    const weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28]; // 加权因子
    const str = '0123456789ABCDEFGHJKLMNPQRTUWXY';
    // 不用I、O、S、V、Z
    for (let i = 0; i < value.length - 1; i++) {
      Ancode = value.substring(i, i + 1);
      Ancodevalue = str.indexOf(Ancode);
      total = total + Ancodevalue * weightedfactors[i];
      // 权重与加权因子相乘之和
    }
    let logiccheckcode = 31 - total % 31;
    if (logiccheckcode === 31) {
      logiccheckcode = 0;
    }
    const Str = '0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y';
    const Array_Str = Str.split(',');
    const checkscode = Array_Str[logiccheckcode];

    const checkcode = value.substring(17, 18);
    if (checkscode !== checkcode) {
      return false;
    }
    return true;
  }
}

function busCode(value) {
  if (!value) {
    return true;
  }
  if (value.length === 15) {
    const s = [];
    const p = [];
    const a = [];
    const m = 10;
    p[0] = m;
    for (let i = 0; i < value.length; i++) {
      a[i] = parseInt(value.substring(i, i + 1), m);
      s[i] = (p[i] % (m + 1)) + a[i];
      if (s[i] % m === 0) {
        p[i + 1] = 10 * 2;
      } else {
        p[i + 1] = (s[i] % m) * 2;
      }
    }
    if (s[14] % m === 1) {
      // 营业执照编号正确!
      return true;
    } else {
      // 营业执照编号错误!
      return false;
    }
  }
  return false;
}

function guid(len, radix) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = [];
  let i;
  const _radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) {
      uuid[i] = chars[Math.random() * _radix | 0];
    }
  } else {
    // rfc4122, version 4 form
    let r;
    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = Math.random() * 16 | 0;
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}

function addDate(date, days) {
  var d = new Date(date);
  d.setDate(d.getDate() + days);
  var m = d.getMonth() + 1;
  var day = d.getDate();
  if (m < 10) {
    m = "0" + m;
  }
  if (day < 10) {
    day = "0" + day;
  }
  return d.getFullYear() + '-' + m + '-' + day;
}
/** 数字金额大写转换(可以处理整数,小数,负数) */
function smalltoBIG(n) {
  var fraction = ['角', '分'];
  var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  var unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ];
  var head = n < 0 ? '欠' : '';
  n = Math.abs(n);

  var s = '';

  for (var i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
  }
  s = s || '整';
  n = Math.floor(n);

  for (var i = 0; i < unit[0].length && n > 0; i++) {
    var p = '';
    for (var j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p;
      n = Math.floor(n / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
}

function xxShow(type, val) {
  if (!val) return;
  val = String(val);
  if (type == 'name' && val.length > 4) {
    return val.substring(0, 2) + "******" + val.substr(-2);
  } else if (type == 'tel' && val.length == 11) {
    return val.substring(0, 3) + "****" + val.substr(-4);
  } else if (type == 'email') {
    let emailArr = val.split("@") || [];
    let emailVal = emailArr[0];
    let subNum = 2;
    if (emailVal.length < 5 && emailVal.length > 2) {
      subNum = 1;
    } else if (emailVal.length <= 2) {
      return val;
    }
    return emailVal.substring(0, subNum) + "**" + emailVal.substr(Number('-' + subNum)) + '@' + emailArr[1];
  }
  return val;
}

function queryTemplateFile(docType) {
  fileQueryAPI({
    mdlId: 'listTemplates',
    tblBlId: docType
  }).then(res => {
    const row = res.data ? res.data[0] : ''
    if (!row) {
      return window.$message.error('未找到模板文件')
    }
    const DOWNLOAD_PREFIX = '/gb-bigtree-file/download/fileDownload/install';
    window.open(`${DOWNLOAD_PREFIX}${row.fileRte}/${row.fileNm}`, '_blank');
  }).catch(err => {
    window.$message.error(err || '未找到模板文件')
  })
}
/** 生成电子签章
 * element: 挂载的节点
 * text: 公司名称
 * subText: 公司编号
 * width : 印章宽、高度
 */
var getFontStr = (opts) => {
  return `normal normal ${opts.fontWeight} ${opts.fontSize}px 宋体`;
}

function createSeal(element, text, subText = '', width = 200) {
  const radius = width / 2
  const seal = new Seal(element, {
    width: width,
    height: width,
    border: {
      color: "red",
      radius: radius,
      shape: "circle",
      visible: true,
      width: 4
    }
  });
  seal.innerBorderOpts.visible = false
  seal.fiveStarOpts.size = width / 5
  seal.borderOpts.radius = radius
  seal.textOpts = {
    visible: true,
    fontSize: text.length > 18 ? 16 : width < 200 ? 18 : 18,
    fontWeight: 600,
    text: text,
    radius: radius - 10,
    startDegree: 45
  }
  seal.serNoOpts.fontSize = 14
  seal.serNoOpts.fontWeight = 600
  seal.serNoOpts.text = ` ${subText} `
  seal.serNoOpts.radius = radius - 10
  seal.serNoOpts.startDegree = 35
  seal.context.font = getFontStr(seal.textOpts);
  seal.update({
    showTransparent: false,
    color: '#f86b65',
    context: {
      font: getFontStr(seal.textOpts)
    }
  })
  seal.context.font = getFontStr(seal.textOpts);
  console.log(seal)
}

const utils = {
  createSeal,
  queryTemplateFile,
  deepClone,
  splitK,
  dateFormat,
  isUndefined,
  clearNoNum,
  getPasswordEncryptString,
  regExpObj,
  fileDownload,
  creditCode,
  busCode,
  getUrlEncrypt,
  getUrlDecrypt,
  encryptItemFromArray,
  decryptItemFromArray,
  guid,
  addDate,
  smalltoBIG,
  xxShow,
  getDate
}
export default utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js